import { createGlobalStyle } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import * as style from 'styles';

export const GlobalStyle = createGlobalStyle`
    html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, code, del, dfn, em, img, q, dl, dt, dd, ol, ul, fieldset, form, label, legend, textarea, table, caption, tbody, tfoot, thead, tr, th, td {
      margin: 0;
      padding: 0;
      border: 0;
      font-weight: inherit;
      font-style: inherit;
      font-family: inherit;
      line-height: 24px;
    }

    html,
    body {
      height: 100%;
      width: 100%;
      line-height: 1.5;
      font-weight: ${style.fontweight.regular};
      color: ${themeGet('colors.blacks.1')};
      font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: ${themeGet('fontSizes.1')}px;
      overflow: hidden;
      letter-spacing: .000001px;
      // -webkit-font-smoothing: antialiased;
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: none;
      cursor: auto;
    }

    body.fontLoaded {
      font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 14px;
    }

    #root {
      background-color: ${themeGet('colors.cream.0')};
      height: 100%;
      width: 100%;
    }

    ::selection {
      color: #241c15;
      background: ${themeGet('colors.blues.5')};;
    }

    p,
    label {
      line-height: 1.5em;
      font-size: 14px;
    }

    a {
      transition: color 125ms ease-in-out;
      color: ${themeGet('colors.bluesV2.6')};
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      color: ${style.color.black.nine};
      line-height: 1.25;
      outline: 0;
      font-weight: ${style.fontweight.light};
    }

    h1 {
      font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 2.25rem;
      font-weight: 400;
      line-height: 1.1;
    }

    h2 {
      font-size: 2rem;;
    }

    h3 {
      font-size: 1.5rem;
      font-weight: ${style.fontweight.regular};
    }

    h4 {
      font-size: 1.25rem;
      font-weight: ${style.fontweight.regular};
    }

    h5 {
      font-size: 1rem;
      font-weight: ${style.fontweight.regular};
    }

    button {
      background:none;
      border:none;
    }

    ::-webkit-input-placeholder { /* Edge */
      font-size: 14px !important;
      color: #bfbfbf;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px !important;
      color: #bfbfbf;
    }

    ::placeholder, .ant-select-selection-placeholder {
      font-size: 14px !important;
      color: #bfbfbf;
      opacity: 1;
    }

    :not(body) {
      background-repeat: no-repeat;
      outline: none;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #b2b2b2;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      border-radius: 4px;
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled),
    .ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner,
    .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
      background-color: ${themeGet('colors.grays.3')} !important;
      font-size: 14px;
      font-weight: ${style.fontweight.regular};
      margin: 2px 0;
    }

    .react-responsive-modal-closeButton {
      top: 30px !important;
      right: 30px !important;
    }
    .ant-form {
      color: ${themeGet('colors.blacks.1')};
    }
    .ant-picker-suffix {
      margin-top: -7px;
    }
    .ant-input-password {
      input.ant-input {
        border: none !important;
        padding: 0 !important;
      }
    }
    .ant-input-group-compact {
      &:after {
        content: none !important;
      }
      &:before {
        content: none !important;
      }
    }
    .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
      border-color: ${themeGet('colors.blacks.1')} !important;
    }
    .ant-picker-today-btn, .ant-picker-now-btn {
      color: ${themeGet('colors.blacks.1')} !important;
    }
    .ant-checkbox-checked .ant-checkbox-inner, .ant-checkbox-disabled .ant-checkbox-inner {
      background-color: ${themeGet('colors.blacks.1')} !important;
      border-color: ${themeGet('colors.blacks.1')} !important;
    }
    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: rgba(255, 255, 255, 0.5);
    }
    .ant-select-item-option-grouped {
      padding-left: 10px !important;
      border-radius: 4px;
    }
    .ant-notification-notice-message {
      font-weight: ${style.fontweight.medium};
    }
    .ant-checkbox {
      margin-right: 5px !important;
    }
    [ant-click-animating-without-extra-node]:after {
      animation: none !important;
    }
    .ant-picker-now {
      display: none !important;
    }
    .ant-btn-primary {
      background-color: ${style.color.black.nine} !important;
      border-color: ${style.color.black.nine} !important;
      box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15) !important;
      color: ${style.color.white} !important;
      height: 100% !important;
  
      &:hover {
        background-color: ${style.color.black.nine} !important;
        border-color: ${style.color.black.nine} !important;
      }
    }
    .rbc-addons-dnd-drag-preview {
      background: ${themeGet('colors.grays.5')} !important;
      border: 1px solid white !important;
      color: ${themeGet('colors.blacks.1')} !important;
      font-size: 12px !important;
      padding: 4px 8px !important;
      border-radius: 8px !important;
      outline: none !important;
      display: flex !important;
      align-items: flex-start !important;

      .rbc-event-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
    }
    .ant-form-item-label {
      label {
        font-weight: ${style.fontweight.medium};
        color: ${style.color.black.nine};
      }
    }
    .ant-form-item-required {
      &:before {
        display: none !important;
      }
      &:after {
        display: inline-block !important;
        margin-left: 4px !important;
        color: ${style.color.red.four} !important;
        font-size: 14px !important;
        font-family: SimSun, sans-serif !important;
        line-height: 1 !important;
        content: '*' !important;
      }
    }
    .ant-tooltip {
      .ant-tooltip-inner {
        background-color: ${style.color.black.nine};
        font-weight: ${style.fontweight.regular};
        box-shadow: none;
        border-radius: 2px;
        padding: ${style.spacing.one};
        font-size: ${style.fontsize.small};
      }
      .ant-tooltip-arrow-content {
        background-color: ${style.color.black.nine};
      }
    }
    .surface-avatar-menu {
      font-size: 14px;
      .ant-popover-content {
        width: 275px;
        transition: all 50ms ease-in;
        transition-property: opacity, width;

        .ant-popover-arrow {
          display: none;
        }

        .ant-popover-inner {
          display: flex;
          position: relative;
          border-radius: 4px;
          background-color: #ffffff;
          box-shadow: 0 2px 10px rgba(0,0,0,.1);
          overflow: auto;
          min-width: 0;
          order: 1;

          .ant-popover-inner-content {
            padding: 0;
            width: 100%;
            color: ${style.color.black.nine};
          }
        }
      }
    }
    .ant-message-notice-content {
      border-radius: 4px !important;

      .ant-message-custom-content {
        display: flex;
        align-items: center;
        font-weight: ${style.fontweight.medium};
      }
    }
    .ant-pagination-item-link {
      .anticon {
        vertical-align: 2px !important;
      }
    }
    .ant-pagination-item, .ant-pagination-prev a, .ant-pagination-next a {
      border-radius: 4px !important;
      &.ant-pagination-item-active:focus a, &.ant-pagination-item-active:hover a {
        color: ${style.color.mint.ten};
      }
      a {text-decoration: none; line-height: 31px;}
    }
    .ant-pagination-prev a, .ant-pagination-next a {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    .ant-pagination-item-active, .ant-pagination-item-active a, .ant-pagination-item-active:hover {
      border-color: ${style.color.black.nine};
      color: ${style.color.black.nine};
    }
    .popover-menu {
      width: 200px;

      &.ant-popover-placement-bottom, &.ant-popover-placement-bottomLeft, &.ant-popover-placement-bottomRight {
        padding-top: 5px;
      }

      .ant-popover-inner {
        display: flex;
        position: relative;
        border-radius: 8px;
        background-color: #ffffff;
        box-shadow: 0 4px 17px 6px rgba(0, 0, 0, 0.1);
      }

      .ant-popover-inner-content {
        padding: 8px !important;
        width: 100%;
      }
    }
    .popover-menu-md {
      width: 350px;

      &.ant-popover-placement-bottom, &.ant-popover-placement-bottomLeft, &.ant-popover-placement-bottomRight {
        padding-top: 5px;
      }

      .ant-popover-inner {
        display: flex;
        position: relative;
        border-radius: 8px;
        background-color: #ffffff;
        box-shadow: 0 4px 17px 6px rgba(0, 0, 0, 0.1);
      }

      .ant-popover-inner-content {
        padding: 8px !important;
        width: 100%;
      }
    }
    .calendar-popover-menu {
      min-width: 200px;

      &.ant-popover-placement-bottom, &.ant-popover-placement-bottomLeft, &.ant-popover-placement-bottomRight {
        padding-top: 5px;
      }

      .ant-popover-inner {
        display: flex;
        position: relative;
        border-radius: 8px;
        background-color: #ffffff;
        box-shadow: 0 4px 17px 6px rgba(0, 0, 0, 0.1);
      }

      .ant-popover-inner-content {
        padding: 8px !important;
        width: 100%;
      }
    }
    .fullscreen-modal {
      width: 100% !important;
      max-width: 100%;
      margin: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100vh;
      display: flex;

      .ant-modal-content {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        display: flex;
        width: 100%;
        justify-content: center;

        .ant-modal-body {
          width: 100%;
        }
      }
    }
    :checked {
      background-color: ${style.color.mint.ten};
      border: ${style.color.mint.ten};
    }

    /**
    * Mask
    */
   .ant-modal-mask {
    background: rgba(82,82,87,.8);
   }

   /**
   * Ant Modal
   **/
   .ant-modal {
     color: ${style.color.black.nine};
   }

   /**
   * Rodal Modal 
   */
   .rodal-dialog {
     width: 100% !important;
   }

   /**
   * Dropdown
   */
  .ant-select-dropdown {
    box-shadow: ${themeGet('shadows.dropdown')};
    border-radius: 4px;
    border: 1px solid #dedddc;
    background: #FFFFFF;
    color: ${themeGet('colors.blacks.1')};
    padding: 0;
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
    color: ${style.color.white.ten};
    display: flex;
    align-items: center;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: ${themeGet('colors.grays.4')};
  }

  /**
  * Popover
  */
  .ant-popover {
    .ant-popover-inner {
      line-height: 20px;
      background-color: ${style.color.white.ten};
      border: 1px solid ${style.color.gray.three};
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      color: ${style.color.gray.three};

      .ant-popover-inner-content {
        position: relative;
      }
    }
    &.calendar-event-select {
      &.ant-popover-placement-right {
        padding-left: 20px !important;
      }
      &.ant-popover-placement-left {
        padding-right: 20px !important;
      }
      &.ant-popover-placement-rightTop {
        margin-top: -100px !important;
      }
      .ant-popover-arrow {
        display: none;
      }
    }
  }
  .ant-select-item {
    min-width: fit-content;
    font-size: 14px;
    color: ${style.color.black.nine};
  }

  /**
  * Form Error
  */
    .ant-form-item-has-error {
      .ant-input-password, .ant-input {
        border-color: ${style.color.red.four} !important;
        box-shadow: inset 0 0 0 1px ${style.color.red.four} !important;
        &:focus, &.ant-input-affix-wrapper-focused {
          border-color: ${style.color.red.four} !important;
          box-shadow: inset 0 0 0 1px ${style.color.red.four} !important;
        }
      }
      .ant-input-password {
        input {
          box-shadow: none !important;
        }
      }
    }
    .ant-form-item-has-error.ant-form-item-has-feedback .ant-form-item-children-icon {
      color: ${style.color.red.four} !important;
    }
    .ant-form-item-has-error .ant-form-item-explain {
      color: ${style.color.red.four} !important;
      margin-top: ${style.spacing.one};
    }

    /**
    * Form Success
    */
   .ant-form-item-has-success.ant-form-item-has-feedback .ant-form-item-children-icon {
    color: ${style.color.mint.ten} !important;
   }

    /**
    * Form Explain
    */
    .ant-form-item-explain {
      display: none;
    }
    .ant-form-item-with-help {
      margin-bottom: 24px;
    }

  /**
  * Temp Event Calendar
  */
  .temp-event-wrapper {
    z-index: 10;
    border-radius: ${style.radius.base};
    background-color: ${style.color.mint.ten};
    color: ${style.color.white.ten};
    border: none !important;
    font-size: 12px;
    width: 100%;
    padding: 4px 6px;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
      0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
  }
 /**
 * Tooltip
 */
.tooltip {
  font-size: ${themeGet('fontSizes.0')}px !important;
  padding: 4px 12px !important;
  max-width: 300px;
  border: 1px solid ${themeGet('colors.grays.3')} !important;
  background: ${themeGet('colors.blacks.1')} !important;
  color: ${themeGet('colors.whites.0')} !important;
  border-radius: 4px !important;

  &.place-right {
    &:before {
      border-right: 8px solid ${themeGet('colors.grays.3')} !important;
    }
  }
  &.place-bottom {
    &:before {
      border-bottom: 8px solid ${themeGet('colors.grays.3')} !important;
    }
  }
  &.place-left {
    &:before {
      border-left: 8px solid ${themeGet('colors.grays.3')} !important;
    }
  }
  &.place-top {
    &:before {
      border-top: 8px solid ${themeGet('colors.grays.3')} !important;
      border-left: none !important;
      border-right: none !important;
    }
  }
  
  * {
    font-size: ${themeGet('fontSizes.0')}px !important;
  }

  p {
    margin-bottom: ${themeGet('space.2')}px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
 /**
 * Popover Default
 */
 .react-tiny-popover-container {
    box-shadow: 0 0 0 1px #E0E0E0,0 5px 20px 0 #151b2614 !important;
    min-width: 150px;
    border-radius: ${themeGet('radii.2')}px;
    z-index: 100;
 }
.popover-default {
    box-shadow: 0 2px 10px rgba(0,0,0,.1);
    border-radius: ${style.radius.base};
    border: 1px solid ${style.color.gray.three};
    background: ${style.color.white.ten};
    padding: ${style.spacing.two};
    min-width: 200px;
 }
 /**
 * Popover List Menu
 */
 .popover-list-menu {
    box-shadow: ${themeGet('shadows.dropdown')};
    border-radius: ${themeGet('radii.2')}px;
    background: #FFF;
    padding: 0;
    min-width: 200px;
    z-index: 99999;
 }
 /**
 * Navbar Menu
  */
 .popover-navbar-menu {
    box-shadow: ${themeGet('shadows.dropdown')};
    border-radius: ${themeGet('radii.1')}px;
    background: #FFF;
    min-width: 200px;
    z-index: 99999;
    max-width: 450px;
    margin-bottom:8px;
 }
 
  /**
  * Create Event Popover
  */
 .popover-create-event {
    box-shadow: ${themeGet('shadows.dropdown')};
    border-radius: ${themeGet('radii.2')}px;
    background: #FFF;
    min-width: 200px;
    margin-top: 12px;
    max-width: 450px;
    overflow: visible !important;
    z-index: 20;
 }

 /**
 * Calendar Popover
 */
  .rbc-overlay {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: ${style.radius.base};
    border: 1px solid ${style.color.gray.three};
    background: ${style.color.white.ten};
    padding: ${style.spacing.one};
    color: ${style.color.black.nine};
    z-index: ${style.zIndex.md};
    margin-top: 12px;
    max-width: 450px;
    overflow: visible !important;
  }
  /**
  * Select
  */
  .ant-select-selection-item-content {
    font-size: 14px !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-search {
    height: 40px;
  }
  .styled-select__menu {
    box-shadow: ${themeGet('shadows.dropdown')} !important;
    min-width: 150px;
    border-radius: ${themeGet('radii.2')}px;
    height: min-content;

    > div {
      padding: 0 !important;
    }
  }
  .styled-select__option {
    color: ${themeGet('colors.blacks.1')} !important;
    border-radius: ${themeGet('radii.1')}px;
    margin: 4px 0px 12px 4px;
    width: calc(100% - 10px) !important;
    position: relative;
    padding: 6px 12px !important;
    display: flex !important;
    align-items: center !important;

    svg {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }

    &:last-of-type {
      margin-bottom: 6px;
      &:after {
        width: 0;
      }
    }

    &:after {
      content: '';
      width: calc(100% + 12px);
      height: 1px;
      position: absolute;
      left: -6px;
      bottom: -6px;
      background: ${themeGet('colors.grays.5')};
    }
  }
  .styled-select__option svg {
    width: 16px;
    height: 16px;
  }
  .styled-select__option--is-focused {
    background-color: ${themeGet('colors.grays.6')} !important;
  }
  .styled-select__option--is-selected {
    background-color: ${themeGet('colors.grays.5')} !important;
  }

  /**
  * Button
  */
 .ant-btn:hover, .ant-btn:focus {
  color: ${style.color.mint.ten};
  background: #fff;
  border-color: ${style.color.mint.ten};
 }
`;
